import { Injectable } from '@angular/core';

/**
 * Service to manage browser cookies with expiration support
 */
@Injectable({
  providedIn: 'root',
})
export class CookieService {
  /**
   * Set a cookie with expiration days
   * @param name Cookie name
   * @param value Cookie value
   * @param days Number of days until expiration
   */
  setCookie(name: string, value: string, days: number): void {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/`;
  }

  /**
   * Get a cookie value by name
   * @param name Cookie name
   * @returns Cookie value or null if not found
   */
  getCookie(name: string): string | null {
    const nameEQ = `${name}=`;
    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
      const trimmedCookie = cookie.trim();
      if (trimmedCookie.startsWith(nameEQ)) {
        return trimmedCookie.substring(nameEQ.length);
      }
    }
    return null;
  }

  /**
   * Delete a cookie by name
   * @param name Cookie name
   */
  deleteCookie(name: string): void {
    this.setCookie(name, '', -1);
  }
}
